module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-09-52b1b703b43dd3ba7cb9b47150b4fea7.jpg";